import template from './bProcessProblemsChart.html';
import moment from 'moment';
import d3 from 'd3';

const COLORS = [
  '#5479BD',
  '#00A990',
  '#F29C9C',
  '#FF644B',
  '#D4E458',
  '#50695F',
  '#EAA21C',
  '#80CBC480',
  '#5A6AA8',
  '#00838A',
  '#76b42c'
];

export function bProcessProblemsChartDirective() {
  'ngInject';
  return {
    restrict: 'E',
    template: template,
    controller: bProcessProblemsChartController,
    controllerAs: 'bProcessProblemsChart',
    bindToController: true,
    scope: {
      tooltipId: "@",
      data: "=",
      canShare: "=",
      onShareChart: "&",
      onExportChart: "&"
    }
  };
}

class bProcessProblemsChartController {
  constructor($filter, $scope, $translate, $rootScope, $routeParams) {
    'ngInject';

    this.$filter = $filter;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$routeParams = $routeParams;
    this.$translate = $translate;
    this.title = this.$translate.instant('VIEW360.PROCESS_PROBLEMS');
    this.seriesVisibility = {};
    this.datesProblemsMap = {};
    this.$scope.$watch(() => this.data, newValue => this.updateChart(newValue));
  }

  exportChart() {
    this.$rootScope.exportProcessProblemsChart = this.data;
    this.onExportChart({exportData: {type: 'ProcessProblems'}});
  }

  getRectTooltipPosition(node) {
    const bcr = node.getBoundingClientRect();
    return {top: bcr.top - 46, left: bcr.left - 30};
  }

  shareChart() {
    const shareData = {type: 'process_problems'};
    this.onShareChart({shareData});
  }

  updateChart(newValue) {
    if (!newValue || !newValue.values) {
      return;
    }
    var self = this;
    const tooltipId = this.tooltipId;
    // TODO: Delete mocks before production launch
    // const pp = [];
    // let date = moment('2019-11', 'YYYY-MM');
    // for (let i = 0; i < 15; i++) {
    //   date = date.subtract(1, 'month');
    //   const numOfProblems = Math.floor(Math.random() * 6);
    //   const problems = [];
    //   for (let j = 0; j < numOfProblems; j++) {
    //     problems.push({
    //       count: Math.floor(Math.random() * 1000),
    //       name: `Problem ${j}`
    //     });
    //   }
    //   pp.push({
    //     date: date.format('YYYY-MM'),
    //     problems: problems
    //   });
    // }

    const pp = newValue.sort((a, b) => {
      const date1 = moment(a.date, 'YYYY-MM').valueOf();
      const date2 = moment(b.date, 'YYYY-MM').valueOf();
      return date2 - date1;
    });
    const data = [];
    this.datesProblemsMap = {};
    const allDates = pp.map(p => p.date);
    const colorsMap = {};
    pp.forEach(dp => {
      dp.problems.forEach(problem => {
        let color;
        if(colorsMap[problem.name]){
          color = colorsMap[problem.name];
        }else{
          const usedColorsLen = Object.keys(colorsMap).length;
          color = usedColorsLen > COLORS.length ? '#' + ((1 << 24) * Math.random() | 0).toString(16) : COLORS[usedColorsLen];
          colorsMap[problem.name] = color;
        }
        if (!this.datesProblemsMap[dp.date]) {
          this.datesProblemsMap[dp.date] = {};
        }

        this.datesProblemsMap[dp.date][problem.name] = {
          name: problem.name,
          val: problem.count
        };

        const problemIdx = data.findIndex(dd => dd.key === problem.name);
        if (problemIdx < 0) {
          data.unshift({key: problem.name, color: color, values: [{x: dp.date, y: problem.count}]});
        } else {
          data[problemIdx].values.push({x: dp.date, y: problem.count});
        }
      });
    });
    // All values must be the same length.
    data.forEach(d => {
      if (d.values.length !== allDates.length) {
        allDates.forEach(dd => {
          if (!d.values.find(item => item.x === dd)) {
            d.values.push({x: dd, y: 0});
          }
        });
      }
      this.seriesVisibility[d.key] = true;
      d.values = d.values.sort((a, b) => a.x.localeCompare(b.x));
    });

    var singleValue = pp.length === 1;
    if (singleValue) {
      data.forEach(item => {
        const dateBefore = moment(pp[0].date, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
        const dateAfter = moment(pp[0].date, 'YYYY-MM').add(1, 'month').format('YYYY-MM');
        item.values.push({x: dateAfter, y: 0});
        item.values.unshift({x: dateBefore, y: 0});
      });
    }

    const chartSizeConst = {
      xTickPadding: 28,
      yTickPadding: 15,
      xLabelHeight: 20,
      chartHeight: 260
    };
    this.chartOptions = {
      chart: {
        type: 'multiBarChart',
        noData: this.$translate.instant('NOTHING_TO_SHOW'),
        height: chartSizeConst.chartHeight,
        stacked: true,
        showControls: false,
        reduceXTicks: false,
        margin: {
          left: 70,
          right: 0,
          top: 0,
          bottom: chartSizeConst.xLabelHeight + chartSizeConst.xTickPadding
        },
        tooltip: {
          position: () => {
            const tooltipEl = angular.element(document.getElementById(`view-360-tooltip-${tooltipId}`));
            const parent = tooltipEl.parent();
            if (tooltipEl && parent && !parent.hasClass('view-360-tooltip')) {
              parent.addClass('view-360-tooltip');
            }

            const rect =  angular.element(document.getElementsByClassName('hover'));
            if(!rect || !rect.length){
              return {};
            }

            return this.getRectTooltipPosition(rect[0]);
          },
          contentGenerator: function (d) {
            const month = moment(d.data.x, 'YYYY-MM').format('MMMM').toUpperCase();
            if (!self.datesProblemsMap[d.value]) {
              return;
            }
            const problemData = self.datesProblemsMap[d.value][d.data.key];
            const value = problemData ? problemData.val : '';
            return `
                <div id="view-360-tooltip-${tooltipId}" class="view-360-tooltip-inner">
                 <div>${month}</div>
                 <div>${d.data.key}</div>
                 <div>${value}</div>
                </div>`;
          }
        },
        xAxis: {
          tickPadding: chartSizeConst.xTickPadding,
          tickValues: d => d[0].values.map(ym => ym.x),
          tickFormat: d => {
            if (singleValue && d !== pp[0].date) {
              return '';
            }
            return moment(d).format('MMM').toUpperCase();
          }
        },
        yAxis: {
          showMaxMin: true,
          tickPadding: chartSizeConst.yTickPadding,
          tickFormat: d => d3.format('d')(d),
          tickValues: () => {
            const visibleProblems = Object.keys(self.seriesVisibility).filter( key => self.seriesVisibility[key]);
            let maxValue = 0;
            allDates.forEach( date => {
              let currentMax = 0;
              visibleProblems.forEach(problem => {
                if(self.datesProblemsMap[date] && self.datesProblemsMap[date][problem]){
                  currentMax += self.datesProblemsMap[date][problem].val;
                }
              });
              maxValue = currentMax > maxValue ? currentMax : maxValue;
            });

            if(maxValue <= 0){
              return [];
            }
            const tickVals = [0];
            const tickVal = Math.ceil(maxValue / 6);
            for (let t = tickVal; t <= maxValue; t += tickVal) {
              tickVals.push(t);
            }
            tickVals.push(maxValue);
            return tickVals;
          }
        }
      },
      data: data
    };
    if(!this.hasSharedView()){
      for (const key of Object.entries(this.seriesVisibility)) {
        this.seriesVisibility[key] = !!this.$rootScope.processProblemsShared && !!this.$rootScope.processProblemsShared.includes(key);
      }
    }
    this.$rootScope.dataProcessProblemChart = angular.copy(this.data);
  }

  hasSharedView(){
    return window.location.pathname.includes('shared');
  }

  toggleLegend(type, idx) {
    if(!this.hasSharedView()){
      this.seriesVisibility[type] = !this.seriesVisibility[type];
      if (Object.values(this.seriesVisibility).filter(x => x).length === 0) {
        Object.keys(this.seriesVisibility).forEach((key) => {
          this.seriesVisibility[key] = true;
        });
      }

      const legend = d3.select(`.bProcessProblemsChart .nv-series:nth-child(${idx + 1})`).node();
      legend.dispatchEvent(new MouseEvent('click'));

      this.$rootScope.legendToggleProblemsChart = angular.copy(this.seriesVisibility);

      let processProblems = [];
      for (const [key, value] of Object.entries(this.$rootScope.legendToggleProblemsChart)) {
        if(value === true) processProblems.push(key);
      }

      this.$rootScope.dataProcessProblemChartProcessProblems = processProblems;

      let tempArr = angular.copy(this.data);
      tempArr.map((x) => {
        x.problems.map((y) => {
          if(!processProblems.includes(y.name)){
            y.count = 0;
            x.name = 0;
          }
        });
      });
      this.$rootScope.dataProcessProblemChart = tempArr;
    }
  }
}
